import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './App.css';
import VideoCanvas from './VideoCanvas';
import VideoStreamComponent from './VideoStreamComponent';
import { 
    FormControl, 
    InputLabel, 
    Select, 
    MenuItem, 
    Button, 
    Grid, 
    Typography,
    Box,
    TextField,
    CircularProgress
  } from '@mui/material';

  import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import DescriptionIcon from '@mui/icons-material/Description';


const AREAS = {
    "Giridih": "Giridih",
    "Dhori": "Dhori",
    "Kathara": "Kathara",
    "Piparwar": "Piparwar",
    "NK": "NK",
    "Rajhara": "Rajhara",
    "Magadh": "Magadh",
    "Barka Sayal": "Barka Sayal",
    "Argada": "Argada",
    "Hazaribagh": "Hazaribagh",
    "Rajrappa": "Rajrappa",
    "B&K": "B&K",
    "Amrapali": "Amrapali",
    "Kuju": "Kuju"
    
  };

const LOCATIONS = {
  'Kuju': [
   
    "KARMA EXIT GATE (CP3103)",
    "KARMA ENTRY GATE (CP3102)",
    "SARUBERA ENTRY GATE (CP3108)",
    "SARUBERA EXIT GATE (CP3109)",
    "KUJU NEW SIDING CHECKPOST ENTRY (CP0921)",
    "TOPA CHECKPOST ENTRY (CP0911)",
    "TOPA CHECKPOST EXIT (CP0912)",
    "KUJU NEW SIDING CHECKPOST EXIT (CP0922)"
  ],

  "Giridih":[
    "GIRIDIH CHECKPOST EXIT (CP1512)",
    "GIRIDIH CHECKPOST ENTRY (CP1511)"
  ],
  "Dhori":[
    "OLD AMLO CHECKPOST EXIT (CP1232)",
    "OLD AMLO CHECKPOST ENTRY (CP1231)",
    "KARIPANI CHECKPOST EXIT (CP1212)",
    "KARIPANI CHECKPOST ENTRY (CP1211)",
    "AMLO CHECKPOST NEW - EXIT (CP1233)",
    "AMLO CHECKPOST NEW - ENTRY (CP1234)"

  ],
  "Kathara":[
    "GOVINDPUR CHECKPOST ENTRY (CP0531)",
      "GOVINDPUR CHECKPOST EXIT (CP0532)",
      "JARANGDIH QUERY CHECKPOST ENTRY (CP0511)",
      "JARANGDIH QUERY CHECKPOST EXIT (CP0512)",
      "JARANGDIH SIDING CHECKPOST EXIT (CP0522)",
      "JARANGDIH SIDING CHECKPOST ENTRY (CP0521)",
      "JRD WB Checkpost 1",
      "Govindpur Checkpost",
      "JRD WB Checkpost 2"

  ],
  "Piparwar":[
    "CHP GATE",
    "Rajdhar Siding CISF CHECK POST",
    "Ashoka Rajdhar Checkpost EXIT (CP1332)",
    "Ashoka Rajdhar Checkpost Entry (CP1331)",
    "Amarpali to CHP CPP checkpost ENTRY (CP1341)",
    "Amarpali to CHP CPP checkpost EXIT (CP1342)",
    "CHP checkpost near road wb12 ENTRY (CP1321)",
    "CHP checkpost near road wb12 EXIT (CP1322)",
    "GOLAMBAR CHECKPOST ENTRY (CP1311)",
    "GOLAMBAR CHECKPOST EXIT (CP1312)"  
  ],
  "NK":[

  ],
  "Rajhara":[

  ],
  "Magadh":[
    "MS Areas Checkpost 11 - Entry (CP0621)",
    

  ],
  "Barka Sayal":[
    "BURKUNDA EXIT CHECK POST (CP3022)",
    "BURKUNDA ENTRY CHECK POST (CP3021)",
    "Potanga Checkpost (CP0125)",
    "Potanga Checkpost Exit (CP0126)",
    "NEW BIRSA CHECKPOST EXIT (CP0112)",
    "NEW BIRSA CHECKPOST ENTRY (CP0111)",
    "Hesabeda Checkpost Exit (CP0129)",
    "Hesabeda Checkpost Entry (CP0128)",
    "NEW SAYAL D CHECKPOST ENTRY (CP0123)"
  ],
  "Argada":[
    "Giddi A EXIT GATE (CP3052)",
    "Giddi A ENTRY GATE (CP3051)",
    "SIRKA ENTRY GATE (CP3005)",
    "SIRKA EXIT GATE (CP3006)",
    "Giddi C ENTRY GATE (CP3053)",
    "Giddi C EXIT GATE (CP3054)",
    "OCP Checkpost No. 2+Dumper Yard",
    "Checkpost - GiddiA",
    "New Checkpost Religara",
    "Giddi C Checkpost"
  ],
  "Hazaribagh":[
    "KEDLA WASHERY CHECKPOST ENTRY (CP1022)",
    "Tapin North Checkpost Entry (CP1004)",
    "Tapin North Checkpost Entry (CP1003)",
    "Tapin south checkpost EXIT (CP1002)"

  ],
  "Rajrappa":[
    "Checkpost Cam 2",
    "Checkpost Cam 3", 
    "Rajrappa ENTRY Gate (CP1101)",
    "Rajrappa EXIT Gate (CP1102)",
  ],
  "B&K":[
    "BOKARO OC CHECKPOST EXIT (CP0422)",
    "BOKARO OC CHECKPOST ENTRY (CP0421)",
    "KARO CHECKPOST EXIT (CP0412)",
    "KARO CHECKPOST ENTRY (CP0411",
    "kmp CCL Checkpost"


  ],
  "Amrapali":[

  ]
};
  
  const LOCATION_CAMERA_IPS = {
  
//GIRIDIH
    "GIRIDIH CHECKPOST EXIT (CP1512)":[
      
            "172.24.190.61"
    ],
      "GIRIDIH CHECKPOST ENTRY (CP1511 )":[
        "172.24.190.55"
      ],
        "SARUBERA ENTRY GATE (CP3108)":[
        "172.24.198.54"
        ],
        "SARUBERA EXIT GATE (CP3109)":[
        "172.24.198.60"
        ],

        "KARMA ENTRY GATE (CP3102)":[
          "172.24.198.70"
        ],
        "KARMA EXIT GATE (CP3103)":[

          "172.24.198.73"
        ],

        "TOPA CHECKPOST ENTRY (CP0911)" :[
        "172.24.185.26"
        ],
        "TOPA CHECKPOST EXIT (CP0912)" :[
        "172.24.185.28"
        ],
        "KUJU NEW SIDING CHECKPOST ENTRY (CP0921)" :[
        "172.24.185.10",
        "172.24.185.11"
        ],
        "KUJU NEW SIDING CHECKPOST EXIT (CP0922)":[
        "172.24.185.13"
        ],
        "OLD AMLO CHECKPOST EXIT (CP1232)":[
      "172.24.203.22",
      ],
      "OLD AMLO CHECKPOST ENTRY (CP1231)":[
      "172.24.203.27"
      ],
      "KARIPANI CHECKPOST EXIT (CP1212)":[
      "172.24.203.155",
      "172.24.203.156"
      ],
      "KARIPANI CHECKPOST ENTRY (CP1211)":[
      "172.24.203.146",
      "172.24.203.147"
      ],
      "AMLO CHECKPOST NEW - EXIT (CP1233)":[
      "172.24.203.125",
      "172.24.203.126"
      ],
      "AMLO CHECKPOST NEW - ENTRY (CP1234)":[
      "172.24.203.114",
      "172.24.203.119"
      ],
      "GOVINDPUR CHECKPOST ENTRY (CP0531)":[
"172.24.185.42",
"172.24.185.43"
],
"GOVINDPUR CHECKPOST EXIT (CP0532)":[
"172.24.185.44",
"172.24.185.45"
],
"JARANGDIH QUERY CHECKPOST ENTRY (CP0511)":[
"172.24.201.202",
"172.24.201.203"
],
"JARANGDIH QUERY CHECKPOST EXIT (CP0512)":[
"172.24.201.204",
"172.24.201.205"

],
"JARANGDIH SIDING CHECKPOST EXIT (CP0522)":[
"172.24.201.219",
"172.24.201.220"
],
"JARANGDIH SIDING CHECKPOST ENTRY (CP0521)":[
"172.24.201.221",
"172.24.201.222"
],
"JRD WB Checkpost 1":[
"172.25.2.15",
"172.25.2.16"
],
"Govindpur Checkpost":[
"172.25.3.7"
],
"JRD WB Checkpost 2":[
"172.25.2.17"
],
"CHP GATE":[
"170.20.13.156"
],
"Rajdhar Siding CISF CHECK POST":[
"170.20.13.199"
],
"Ashoka Rajdhar Checkpost EXIT (CP1332)":[
"172.24.190.134",
"172.24.190.135"
],
"Ashoka Rajdhar Checkpost Entry (CP1331)":[
"172.24.190.140",
"172.24.190.141"
],
"Amarpali to CHP CPP checkpost ENTRY (CP1341)":[
"172.24.190.150",
"172.24.190.151"
],
"Amarpali to CHP CPP checkpost EXIT (CP1342)":[
"172.24.190.156",
"172.24.190.157"
],
"CHP checkpost near road wb12 ENTRY (CP1321)":[
"172.24.190.166",
"172.24.190.167"
],
"CHP checkpost near road wb12 EXIT (CP1322)":[
"172.24.190.173",
"172.24.190.174"
],
"GOLAMBAR CHECKPOST ENTRY (CP1311)":[
"172.24.190.182",
"172.24.190.183"
],
"GOLAMBAR CHECKPOST EXIT (CP1312)":[
"172.24.190.188",
"172.24.190.189"
],

"BURKUNDA EXIT CHECK POST (CP3022)":[
"172.24.196.235",
"172.24.196.236"
],
"BURKUNDA ENTRY CHECK POST (CP3021)":[
"172.24.196.237",
"172.24.196.238"
],
"Potanga Checkpost (CP0125)":[
"172.24.190.219",
"172.24.190.220"
],
"Potanga Checkpost Exit (CP0126)":[
"172.24.190.221",
"172.24.190.222"
],
"NEW BIRSA CHECKPOST EXIT (CP0112)":[
"172.24.190.235",
"172.24.190.236"
],
"NEW BIRSA CHECKPOST ENTRY (CP0111)":[
"172.24.190.237",
"172.24.190.238"
],
"Hesabeda Checkpost Exit (CP0129)":[
"172.24.190.202",
"172.24.190.203"
],
"Hesabeda Checkpost Entry (CP0128)":[
"172.24.190.204",
"172.24.190.205"
],
"NEW SAYAL D CHECKPOST ENTRY (CP0123)":[
"172.24.189.150",
"172.24.189.151"
],
"NEW SAYAL D CHECKPOST EXIT (CP0124)":[
"172.124.189.156",
"172.124.189.157"
],


"Giddi A EXIT GATE (CP3052)":[
"172.24.199.91",
"172.24.199.92"
],
"Giddi A ENTRY GATE (CP3051)":[
"172.24.199.93",
"172.24.199.94"
],
"SIRKA ENTRY GATE (CP3005)":[
"172.24.199.75",
"172.24.199.76"
],
"SIRKA EXIT GATE (CP3006)":[
"172.24.199.77",
"172.24.199.78"
],
"Giddi C ENTRY GATE (CP3053)":[
"172.24.199.102"
],
"Giddi C EXIT GATE (CP3054)":[
"172.24.199.104",
"172.24.199.105"
],
"OCP Checkpost No. 2+Dumper Yard":[
"172.18.0.37",
"172.18.0.38",
"172.18.0.39",
"172.18.0.40"
],
"Checkpost - GiddiA":[
"172.18.0.86",
"172.18.0.87"
],
"New Checkpost Religara":[
"172.18.0.122",
"172.18.0.123",
"172.18.0.124",
],
"Giddi C Checkpost":[
"172.18.0.168",
"172.18.0.169"
],


"KEDLA WASHERY CHECKPOST ENTRY (CP1022)":[
"172.24.129.122",
"172.24.129.123",
"172.24.129.124",
"172.24.129.125"
],
"Tapin North Checkpost Entry (CP1004)":[
"172.24.129.155",
"172.24.129.156"
],
"Tapin North Checkpost Entry (CP1003)":[
"172.24.129.157",
"172.24.129.158"
],
"Tapin south checkpost EXIT (CP1002)":[
"172.24.150.250",
"172.24.150.251"
],

"Checkpost Cam 2":[
    "10.105.25.22"
],
    "Checkpost Cam 3":[
    "10.105.25.23"
    ],
    "Rajrappa ENTRY Gate (CP1101)":[
    "172.24.200.37",
    "172.24.200.38",
    ],

    "Rajrappa EXIT Gate (CP1102)":[
    "172.24.200.39",
    "172.24.200.40"
    ],


    "BOKARO OC CHECKPOST EXIT (CP0422)":[
      "172.24.50.122",
      "172.24.50.123"
    ],
    "BOKARO OC CHECKPOST ENTRY (CP0421)":[
      "172.24.50.242",
      "172.24.50.243"
    ],
    "KARO CHECKPOST EXIT (CP0412)":[
      "172.24.49.49",
      "172.24.49.50"
    ],
    "KARO CHECKPOST ENTRY (CP0411":[
      "172.24.49.51",
      "172.24.49.52"
    ],
    "kmp CCL Checkpost":[
      "172.24.85.63"
    ]
};
  
  const CAMERA_NAMES = {
 
  "172.24.198.86":"CAM 1",
    "172.24.198.87":"CAM 2",
    "172.24.198.70":"CAM 3",
    "172.24.198.71":"CAM 4",
    "172.24.198.72":"CAM 5",
    "172.24.198.73":"CAM 6",
   "172.24.185.26":"CAM 10",
"172.24.185.27":"CAM 7",
"172.24.185.28":"CAM 8",
"172.24.185.29":"CAM 9"
    
   



   









    
  };

  const BASE_URL = {
    "Kuju": "https://kuju.cclai.in/report",
    "Dhori": "https://dhori.cclai.in/report",
    "Giridih": "https://giridih.cclai.in/report",
    "Kathara": "https://kathara.cclai.in/report",
    "Piparwar": "https://piparwar.cclai.in/report",
    "NK": "https://nk.cclai.in/report",
    "Rajhara": "https://rajhara.cclai.in/report",
    "Magadh": "https://magadh.cclai.in/report",
    "Barka Sayal": "https://barkasayal.cclai.in/report",
    "Argada": "https://argada.cclai.in/report",
    "Hazaribagh": "https://hazaribagh.cclai.in/report",
    "Rajrappa": "https://rajrappa.cclai.in/report",
    "B&K": "https://bk.cclai.in/report",
    "Amrapali": "https://amrapali.cclai.in/report"

  };

  const ReportTopBar = ({ selectedArea: propSelectedArea, selectedCategory, selectedDetection, onBackToLive }) => {
    // Create a local state that's initialized with the prop value
    const [selectedArea, setSelectedArea] = useState(propSelectedArea);
    const [selectedLocation, setSelectedLocation] = useState('');
    const [selectedCameras, setSelectedCameras] = useState([]);
    const [availableLocations, setAvailableLocations] = useState([]);
    const [availableCameras, setAvailableCameras] = useState([]);
    const [startTime, setStartTime] = useState(new Date(Date.now() - 24 * 60 * 60 * 1000)); // 24 hours ago
    const [endTime, setEndTime] = useState(new Date());
    const [generating, setGenerating] = useState(false);
    const [error, setError] = useState(null);

  
    // Update available locations when area changes
    useEffect(() => {
      if (selectedArea) {
        setAvailableLocations(LOCATIONS[selectedArea] || []);
        setSelectedLocation('');
        setSelectedCameras([]);
        setAvailableCameras([]);
      }
    }, [selectedArea]);
  
    // Update available cameras when location changes
    useEffect(() => {
      if (selectedLocation) {
        const cameraIps = LOCATION_CAMERA_IPS[selectedLocation] || [];
        const cameras = cameraIps.map(ip => ({
          ip: ip,
          name: CAMERA_NAMES[ip] || "Unknown"
        }));
        setAvailableCameras(cameras);
        setSelectedCameras([]);
      }
    }, [selectedLocation]);
  
    const handleAreaChange = (e) => {
        const newArea = e.target.value;
        setSelectedArea(newArea);
      
      // Reset selections
      setSelectedLocation('');
      setSelectedCameras([]);
      setAvailableCameras([]);
      
      // Update available locations
      setAvailableLocations(LOCATIONS[newArea] || []);
    };
  
    const handleLocationChange = (e) => {
      setSelectedLocation(e.target.value);
    };
  
    const handleCameraChange = (e) => {
      setSelectedCameras(e.target.value);
    };
  
    // Generate PDF report
    // Updated generateReport function with proper IST handling
// Alternative fix - update the frontend to match the backend's expected format
const generateReport = async () => {
    if (!selectedArea) {
      setError("Please select an area");
      return;
    }
  
    setGenerating(true);
    setError(null);
  
    try {
      const baseUrl = BASE_URL[selectedArea];
      if (!baseUrl) {
        setError("Invalid area selected");
        setGenerating(false);
        return;
      }
  
      // Format dates to match what backend expects
      const formatDateForAPI = (date) => {
        return {
          localISOString: date.toISOString(),
          timezoneOffsetMinutes: date.getTimezoneOffset()
        };
      };
  
      const payloadArea = selectedArea === "Katras" ? "Sijua" : selectedArea;
      
      const payload = {
        area: payloadArea,
        checkpost: selectedLocation || "All",
        cameraIps: selectedCameras.length > 0 ? selectedCameras : [],
        timeFilter: {
          // Send in the format your backend expects
          startTime: formatDateForAPI(startTime),
          endTime: formatDateForAPI(endTime)
        }
      };
  
      console.log("Sending payload with original format:", payload);
  
      const response = await axios({
        url: `${baseUrl}/generate-pdf`,
        method: 'POST',
        data: payload,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: 60000,
      });

      if (!response.data || response.data.size === 0) {
        throw new Error("Received empty response from server");
      }

      if (response.data.type && !response.data.type.includes('pdf') && !response.data.type.includes('octet-stream')) {
        const text = await response.data.text();
        console.error("Server returned:", text);
        throw new Error(`Server returned unexpected content type: ${response.data.type}`);
      }
  
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      
      const localDate = new Date().toISOString().split('T')[0];
      link.setAttribute('download', `vehicle_report_${localDate}.pdf`);
      
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
  
    } catch (error) {
      console.error("Error generating PDF:", error);
      
      if (error.code === 'ECONNABORTED') {
        setError("Request timed out. Please try again.");
      } else if (error.response) {
        setError(`Server error: ${error.response.status}. Please try again.`);
      } else if (error.request) {
        setError("No response from server. Please check your connection.");
      } else {
        setError(`Failed to generate report: ${error.message}`);
      }
    } finally {
      setGenerating(false);
    }
};
  
    return (
      <Box sx={{ p: 2, borderRadius: 1 }}>
        <Typography variant="h6" gutterBottom>Vehicle Report Generator</Typography>
        
        <Grid container spacing={2}>
          {/* Area Selection */}
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel>Area</InputLabel>
              <Select
                value={selectedArea}
                label="Area"
                onChange={handleAreaChange}
                disabled={generating}
              >
                <MenuItem value="">
                  <em>Select Area</em>
                </MenuItem>
                {Object.keys(AREAS).map(area => (
                  <MenuItem key={area} value={area}>{area}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          
          {/* Location Selection */}
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small" disabled={!selectedArea || generating}>
              <InputLabel>Location</InputLabel>
              <Select
                value={selectedLocation}
                label="Location"
                onChange={handleLocationChange}
              >
                <MenuItem value="">
                  <em>All Locations</em>
                </MenuItem>
                {availableLocations.map(location => (
                  <MenuItem key={location} value={location}>{location}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          
          {/* Camera Selection */}
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small" disabled={!selectedLocation || generating}>
              <InputLabel>Cameras</InputLabel>
              <Select
                multiple
                value={selectedCameras}
                label="Cameras"
                onChange={handleCameraChange}
              >
                {availableCameras.map(camera => (
                  <MenuItem key={camera.ip} value={camera.ip}>
                    {camera.name} ({camera.ip})
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        
        {/* Time range selection */}
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Grid item xs={12} sm={6} md={3}>
              <DateTimePicker
                label="Start Time"
                value={startTime}
                onChange={setStartTime}
                renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                disabled={generating}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <DateTimePicker
                label="End Time"
                value={endTime}
                onChange={setEndTime}
                renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                disabled={generating}
              />
            </Grid>
          </LocalizationProvider>
          
          {/* Generate Button */}
          <Grid item xs={12} sm={6} md={3}>
            <Button
              variant="contained"
              color="primary"
              onClick={generateReport}
              disabled={!selectedArea || generating}
              startIcon={generating ? <CircularProgress size={20} /> : <DescriptionIcon />}
              fullWidth
            >
              {generating ? 'Generating...' : 'Generate Report'}
            </Button>
          </Grid>
        </Grid>
        
        {/* Error message */}
        {error && (
          <Typography color="error" sx={{ mt: 2 }}>
            {error}
          </Typography>
        )}
        
        {/* Back to Live Button */}
        <Box sx={{ mt: 2 }}>
          <Button variant="outlined" onClick={onBackToLive} disabled={generating}>
            Back to Live View
          </Button>
        </Box>
      </Box>
    );
  };
  
  export default ReportTopBar;